import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import PropTypes from "prop-types";

import { Link } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// core components
import Grid from "@mui/material/Grid";

import Button from "../components/Button.jsx";

import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloEditComboBox from '../componentsothello/OthelloEditComboBox.jsx';
import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloModalBase from "../componentsothello/OthelloModalBase.jsx";

import nacionalidades from "../assets/nacionalidades.json";
import provincias from "../assets/provincias.json";


import { DialogOthelloResult, TipoPreguntaEncuenta, OpcionComboBienMalRegularEncuesta, OpcionEstrellasEncuesta, OpcionSiNoEncuesta, OpcionComboUnoDiezEncuesta, PopUpResult, Visibilidad, TipoValidacionEncuenta, DataStateModal, ModoModal} from "../othelloConstantes.jsx";
import OthelloEdit  from "../componentsothello/OthelloEdit.jsx";

import { Helmet } from 'react-helmet'
import OthelloPrimary from "../componentsothello/OthelloPrimary.jsx";
import MDBox from "../components/MDBox/index.js";
import MDTypography from "../components/MDTypography/index.js";
import { Paper } from '@mui/material';
import { Send } from '@mui/icons-material';


export default function FormularioEncuesta({ ...props }) {
    const { literal, idRol, tipooficina, loginmodoreserva, loginapps, idUser } = props;

    //ejemplo url
    //https://gestor.ovtspain.es/formulario/encuesta?id={Id_Oficina}-{tokenid}&data={dataencodedbase64}"

    const navigate = useNavigate();

    const { search } = useLocation();

    const [loading, setLoading] = React.useState(true);

    const [idofi, setidofi] = React.useState(-1);
    const [idenc, setidenc] = React.useState(-1);
    const [preselecccion, setpreseleccion] = React.useState("");
    const [data, setdata] = React.useState(null);
    const [encuesta, setencuesta] = React.useState(null);

    const [guardandoencuesta, setguardandoencuesta] = React.useState(false);
    const [encuestafinalizada, setencuestafinalizada] = React.useState(false);
    const [validado, setvalidado] = React.useState(false);
    const [stateModal, setstateModal] = React.useState(DataStateModal.dsClosed);
    const [modomodal, setmodomodal] = React.useState(null);

    const [codigo, setcodigo] = React.useState("");
    const [dataeditando, setdataeditando] = React.useState(null);

    const [alert, setalert] = React.useState(null);
    const [alertaopcion, setalertaopcion] = React.useState(null);

    const getColumnasProvincias = () => {
        return [{ fieldname: "name", fieldliteralname: "_nombre", width: 300 }]
    }

    React.useEffect(() => {

        let url = search;
        let params = new URLSearchParams(url);

        let identificador = params.get('id');
        let dt = params.get('data');

        let idsplit = identificador.split('-');

        setidofi(idsplit[0]);
        setidenc(idsplit[1]);

        let preselec = "";

        if (idsplit.length >= 2) {
            preselec = idsplit[2];
            setpreseleccion(preselec);
        }

        setdata(dt);

        getDataPage(idsplit[0], idsplit[1], preselec, dt);
    }, [loading]);

    const getDataPage = (idofi, idenc, preselec, data) => {
        if (idofi != null && data != null && idenc != null) {
            var jsonData = JSON.stringify({ idofi: idofi, idenc: idenc, data: data, preselected: preselec });

            fetch('api/Data/GetEncuestaFormulario', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res != null) {
                    setencuesta(res);
                    setLoading(false);
                }
                else {
                    setencuesta({ id_Encuesta: -1 });
                    setLoading(false);
                }
            }).catch(error => {
                setencuesta({ id_Encuesta: -1 });
                setLoading(false);
            });
        }
    }

    const onClosePopUpResult = () => {
        setalert(null);
        setalertaopcion(null);
    }

    const othelloModalResul = (modo, result, valor) => {
        if (result == DialogOthelloResult.OK) {
            var object = "";
            let formulariovalida = document.getElementById('formvalidacion');
            let formvalida = new FormData(formulariovalida);
            formvalida.forEach((value, key) => { object += value + "|" });

            codigo = object;

            if (object != "")
                SendEncuesta();
            else {
                setstateModal(DataStateModal.dsClosed);
                setmodomodal("");
            }
        }
        else {
            setstateModal(DataStateModal.dsClosed);
            setmodomodal("");
        }
    }

    const SendEncuesta = () => {

        let res = "";
        let formulario = document.getElementById('formencuesta');
        let formdata = new FormData(formulario);
        let tipovalidacion = -1;

        var object = {};
        formdata.forEach((value, key) => {

            res += key + '=' + value + '|';

            if (key == "tipovalidacion")
                tipovalidacion = value;

            object[key] = value;
        });

        //Guardo los datos introducidos por el usuario
        setdataeditando({ ...object });

        if (res != null && res != "") {
            if (stateModal == DataStateModal.dsClosed && encuesta.tipoValidacion != TipoValidacionEncuenta.SinValidacion) {
                setstateModal(DataStateModal.dsOpen);
                setmodomodal("login");
            }
            else {
                var jsonData = JSON.stringify({ idofi: encuesta.id_Oficina, idenc: encuesta.id_Encuesta, codigo: codigo, data: res, tipovalidacion: tipovalidacion });

                setguardandoencuesta(true);

                fetch('api/Data/GuardarEncuesta', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {
                    if (res != null) {
                        //Si hubo error
                        if (res.grabada) {
                            setalert(PopUpResult.OK);
                            setguardandoencuesta(false);
                            setencuestafinalizada(true);
                            setstateModal(DataStateModal.dsClosed);
                            setmodomodal(null);
                        }
                        else {
                            setalert(PopUpResult.KO);
                            setguardandoencuesta(false);
                            setalertaopcion(res.error);
                            setstateModal(DataStateModal.dsClosed);
                            setmodomodal(null);
                        }
                    }
                    else {
                        setalert(PopUpResult.KO);
                        setguardandoencuesta(false);
                        setalertaopcion("Error interno al grabar la encuesta");
                        setstateModal(DataStateModal.dsClosed);
                        setmodomodal(null);
                    }

                }).catch(error => {
                    setalert(PopUpResult.KO);
                    setguardandoencuesta(false);
                    setalertaopcion("Error interno al grabar la encuesta");
                    setstateModal(DataStateModal.dsClosed);
                    setmodomodal(null);
                });
            }
        }
        else {
            setalert(PopUpResult.KO);
            setguardandoencuesta(false);
            setalertaopcion("Error interno al grabar la encuesta");
            setstateModal(DataStateModal.dsClosed);
            setmodomodal(null);
        }
    }

    function getPreguntaSegunTipo(id, tipo, valor, opcionesCombo, rowsTextoLibre, defaultValue) {
        if (tipo == TipoPreguntaEncuenta.ComboBienMalRegular)
            return <OthelloComboBox label='' fieldname={id} items={OpcionComboBienMalRegularEncuesta} currentvalue={valor != null ? valor : (defaultValue != null && defaultValue != "" ? defaultValue : 7.5)} />
        else if (tipo == TipoPreguntaEncuenta.ComboUnoDiez)
            return <OthelloComboBox label='' fieldname={id} items={OpcionComboUnoDiezEncuesta} currentvalue={valor != null ? valor : (defaultValue != null && defaultValue != "" ? defaultValue : 5)} />
        else if (tipo == TipoPreguntaEncuenta.SiNo)
            return <OthelloComboBox label='' fieldname={id} items={OpcionSiNoEncuesta} currentvalue={valor != null ? valor : (defaultValue != null && defaultValue != "" ? defaultValue : 0)} />
        else if (tipo == TipoPreguntaEncuenta.Estrellas)
            return <OthelloComboBox label='' fieldname={id} items={OpcionEstrellasEncuesta} currentvalue={valor != null ? valor : (defaultValue != null && defaultValue != "" ? defaultValue : 6)} />
        else if (tipo == TipoPreguntaEncuenta.Combo)
            return <OthelloComboBox label='' fieldname={id} items={opcionesCombo != null ? opcionesCombo : []} currentvalue={valor != null ? valor : (opcionesCombo != null && opcionesCombo.length > 0 ? opcionesCombo[0].valor : "")} />
        else if (tipo == TipoPreguntaEncuenta.TextoLibre)
            return <OthelloEdit label="" fieldname={id} currentvalue={valor != null ? valor : ""} rows={rowsTextoLibre} />
        else if (tipo == TipoPreguntaEncuenta.Provincias)
            return <OthelloEditComboBox labelliteral="" autoselecteditem={true} fieldname={id} othellocolumnas={getColumnasProvincias()} items={provincias} multiple={false} currentvalue={valor != null ? valor : ""} />
        /*return <OthelloComboBox label='' fieldname={id} items={provincias} currentvalue={valor != null ? valor : ""} />*/
        else if (tipo == TipoPreguntaEncuenta.Paises)
            return <OthelloComboBox label='' fieldname={id} items={nacionalidades} currentvalue={valor != null ? valor : nacionalidades[61].valor} />
        else if (tipo == TipoPreguntaEncuenta.PreSelecOpcion)
            return <OthelloComboBox label='' fieldname={id} items={opcionesCombo != null ? opcionesCombo : []} currentvalue={valor != null ? valor : (opcionesCombo != null && opcionesCombo.length > 0 ? opcionesCombo[0].valor : "")} />
        else
            return "";
    }


    function renderPreguntasEncuestas(encuesta) {

        let res = encuesta.preguntas.map(x => {

            let id = x.id_Question + "_" + x.tipo + "_" + x.pregunta;

            let valor = dataeditando != null ? dataeditando[id] : null;

            let opcionesCombo = (x.tipo == TipoPreguntaEncuenta.Combo || x.tipo == TipoPreguntaEncuenta.PreSelecOpcion) && x.opciones != null && x.opciones != "" ? x.opciones.split("|") : "";
            let combofinal = [];

            if (opcionesCombo != null && opcionesCombo.length > 0) {
                opcionesCombo.forEach(y => combofinal.push({ valor: y, name: y }));
            }

            let rowsTextoLibre = x.tipo == TipoPreguntaEncuenta.TextoLibre && x.opciones != null && x.opciones != "" ? parseInt(x.opciones, 3) : 3;

            let visibilidad = true;
            let valorpreselected = -1;

            if (x.tipo == TipoPreguntaEncuenta.PreSelecOpcion && preselecccion != null && combofinal != null && combofinal.length > 0) {
                if (combofinal.some(x => x.valor.toLowerCase() == preselecccion.toLowerCase())) {
                    valorpreselected = combofinal.find(x => x.valor.toLowerCase() == preselecccion.toLowerCase()).valor;
                    visibilidad = false;
                }
            }

            if (visibilidad) {
                return <>
                    <Grid item xs={12} sm={x.tipo != TipoPreguntaEncuenta.TextoLibre ? 12 : 12} md={x.tipo != TipoPreguntaEncuenta.TextoLibre ? 6 : 6} lg={x.tipo != TipoPreguntaEncuenta.TextoLibre ? 6 : 6}>
                        <b> {x.pregunta}</b>
                        {getPreguntaSegunTipo(id, x.tipo, valor, combofinal, rowsTextoLibre, x.defaultValue)}
                        <hr />
                    </Grid>
                </>
            }
            else {
                return <input id={id} name={id} type="hidden" value={valorpreselected} />
            }

        });

        return <><input id="tipovalidacion" name="tipovalidacion" type="hidden" value={encuesta.tipoValidacion} />{res}</>;
    }


    function renderFormularioEncuesta(encuesta, encuestafinalizada) {
        if (encuesta != null && encuesta.id_Encuesta > 0) {
            const preguntas = encuesta.visible === Visibilidad.Si && encuesta.preguntas != null && encuesta.preguntas.length > 0
                ? renderPreguntasEncuestas(encuesta)
                : "";

            return (<MDBox sx={{ mx: 3, pb:5 }}>
                <Paper sx={{ padding: 0, borderRadius: 3, boxShadow: 3 }}>

                    {/* Zona superior con fondo azul suave */}
                    <MDBox sx={{ backgroundColor: "#f7f9fc", px: 3, py: 2, borderTopLeftRadius: 12, borderTopRightRadius: 12, borderBottom: '1px solid #dce3ec' }}>
                        <MDTypography variant="h4" sx={{ fontWeight: 'bold', m: 0 }}>
                            {encuesta.nombre}
                        </MDTypography>
                    </MDBox>
                    {/* Contenido debajo del encabezado */}
                    <MDBox sx={{ px: 3, pt: 0, pb: 2 }}>
                        {encuesta.visible === Visibilidad.Si ? (
                            <form id="formencuesta">
                                {encuestafinalizada !== null && encuestafinalizada ? (
                                    <MDBox>
                                        <Grid container mt={2}>
                                            <MDTypography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                Encuesta finalizada con exito, gracias por tu colaboracion!
                                            </MDTypography>
                                        </Grid>
                                        {encuesta.id_Oficina === 399 && (
                                            <Grid container mt={1} mb={3}>
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        color="info"
                                                        sx={{ float: 'right' }}
                                                        onClick={() => window.location.reload()}
                                                    >
                                                        Hacer Nueva Encuesta
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </MDBox>
                                ) : (
                                    <MDBox>
                                        <Grid container mt={2} spacing={2}>
                                            {preguntas}
                                        </Grid>
                                        <Grid container mt={2} mb={3}>
                                            <Grid item>
                                                <Button
                                                    variant="contained"
                                                    color="info"
                                                    sx={{
                                                        float: 'right',
                                                        '&:hover': {
                                                            backgroundColor: '#F56A00',
                                                        },
                                                    }}
                                                    onClick={() => SendEncuesta()}
                                                    endIcon={<Send />}
                                                >
                                                    Enviar Encuesta
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                )}
                            </form>
                        ) : (
                            <MDTypography variant="body1" color="error">
                                Encuesta no disponible en estos momentos.
                            </MDTypography>
                        )}
                    </MDBox>
                </Paper>
            </MDBox>

            );
        } else {
            return (
                <MDTypography variant="body1" color="error">
                    No se pudo mostrar el formulario, int�ntalo m�s tarde.
                </MDTypography>
            );
        }
    }

    function renderModalValidacionLogin() {
        return (<OthelloModalBase titulo="Validacion Encuesta" modo={ModoModal.SinDefinir} open={stateModal} onCloseResulModal={othelloModalResul} >
            <OthelloPrimary><b>Realice la validacion de su encuesta mediante Login</b></OthelloPrimary>
            <form id="formvalidacion" >
                <Grid container>
                    <Grid item xs={12}>
                        <OthelloEdit label="Usuario o Email..." fieldname="email" />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <OthelloEdit label="Password" type="password" fieldname="password" />
                    </Grid>
                </Grid>
                {guardandoencuesta ? <CircularProgress color="secondary" /> : ""}
                <Grid container xs={12}><Grid item xs={12} sm={4}><Link to="/authapps/register" >Registrate</Link> </Grid>
                    <Grid item xs={12} sm={8}><Link to="/authapps/rememberpass" >He olvidado mi contrase&ntilde;a</Link></Grid>
                </Grid>
            </form>
        </OthelloModalBase>);
    }

    let cargando = loading ? <p><CircularProgress color="secondary" /></p> : "";

    let alertafinal = alert != null ? <OthelloPopUpResult titulo={alertaopcion} alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    let modal = "";

    if (stateModal != DataStateModal.dsClosed && modomodal == "login")
        modal = renderModalValidacionLogin();


    const pageTitle = !loading ? `${encuesta.nombreOficina} - ${encuesta.nombre}` : "Encuesta";
    const headingText = !loading
        ? `${encuesta.nombreOficina} ${preselecccion && preselecccion !== "" ? `- ${preselecccion}` : ""}`
        : "";

    let imageniniciojuego = encuesta != null && encuesta.image != null && encuesta.image != "" ? encuesta.image : null;
        //"http://www.ovtspain.es/iconos//encuesta_satisfaccion_53_1.png" 

    return (
        <MDBox sx={{            
            backgroundImage: `url(${imageniniciojuego})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            width: '100vw',  // ocupa todo el ancho
            minHeight: '80vh',
        }}>
            {alertafinal}
            {modal}
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>           
            {/* Banner informativo */}
            <MDBox sx={{ py: 3, mx: 3}} >
                <Paper
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: 3,
                        backgroundColor: '#003366', // Color suave, t�pico de encuestas de satisfacci�n
                        borderRadius: 3,
                        boxShadow: 4,
                        textAlign: 'center',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.05)', // Animaci�n sutil en hover
                        },
                    }}
                >
                    <MDTypography variant="h3" sx={{ fontWeight: 'bold', color: '#fff', marginBottom: 0 }}>
                        {headingText || 'Ayudanos a mejorar tu experiencia!'}
                    </MDTypography>
                </Paper>
            </MDBox>
            {loading ? (
                <MDBox sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
                    <CircularProgress />
                    {cargando && <MDTypography sx={{ marginLeft: 2 }}>Cargando...</MDTypography>}
                </MDBox>
            ) : (
                renderFormularioEncuesta(encuesta, encuestafinalizada)
            )}
        </MDBox>
    );
}
